var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example-modal"},[_c('p',[_vm._v("Example modal content")]),_c('LoginLink',{staticClass:"button primary"},[_vm._v("Open another")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }